import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

import {
  FooterContainer,
  FooterWrapper,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkTitle,
  FooterLinkItems,
  FooterLink,
  SocialMedia,
  SocialMediaWrapper,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink
} from './footer.styles';
import { footerLinks } from './footer.data';

const Footer = () => {
  const ScrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterLinksContainer>
          {footerLinks.map(({ id, title, links }) => (
            <FooterLinksWrapper key={id}>
              <FooterLinkTitle>{title}</FooterLinkTitle>
              <FooterLinkItems>
                {links.map((item, idx) => (
                  <FooterLink key={idx} to="signin">
                    {item}
                  </FooterLink>
                ))}
              </FooterLinkItems>
            </FooterLinksWrapper>
          ))}
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrapper>
            <SocialLogo to="/" onClick={ScrollToTop}>
              crypto wallet
            </SocialLogo>
            <WebsiteRights>
              crypto wallet &copy; {new Date().getFullYear()} All rights
              reserved.
            </WebsiteRights>
            <SocialIcons>
              <SocialIconLink
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook />
              </SocialIconLink>
              <SocialIconLink
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </SocialIconLink>
              <SocialIconLink
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <FaTwitter />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrapper>
        </SocialMedia>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;

// find better methods to nested maps x => x => x
